import { render, staticRenderFns } from "./IdentifyModal.vue?vue&type=template&id=b83ba684&"
import script from "./IdentifyModal.vue?vue&type=script&lang=js&"
export * from "./IdentifyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IdentifyModal.vue"
export default component.exports